import { configureStore } from '@reduxjs/toolkit';
import userJourneyReducer from './slices/userJourneySlice';
import agentReducer from './slices/updateagentSlice';
import businessReducer from './slices/businessSlice';
import storeReducer from './slices/storeSlice';
import signupReducer from './slices/signupSlice';
import generalSupportReducer from './slices/generalSupportSlice';
import callReducer from './slices/CallSlice';
import reservationReducer from './slices/reservationSlice';
import webhookFunctionReducer from './slices/webhookFunctionSlice';
import webformReducer from './slices/webformSlice';
import multilingualVoiceReducer from './slices/multilingualVoiceSlice';
import versionComparisonReducer from './slices/versionComparisonSlice';
import enhanceSystemPromptReducer from './slices/enhanceSystemPromptSlice';
import callStagesFlowReducer from './slices/callStagesFlowSlice';
import windmillFlowReducer from './slices/windmillFlowSlice';
import toolsReducer from './slices/toolsSlice';
import serverLogsReducer from './slices/serverLogsSlice';
import callsPageReducer from './slices/callsPageSlice';
import brandingReducer from './slices/brandingSlice';
import billingReducer from './slices/billingSlice';

export const store = configureStore({
  reducer: {
    userJourney: userJourneyReducer,
    agent: agentReducer,
    business: businessReducer,
    store: storeReducer,
    signup: signupReducer,
    generalSupport: generalSupportReducer,
    call: callReducer,
    reservation: reservationReducer,
    webhookFunction: webhookFunctionReducer,
    webform: webformReducer,
    multilingualVoice: multilingualVoiceReducer,
    versionComparison: versionComparisonReducer,
    enhanceSystemPrompt: enhanceSystemPromptReducer,
    callStagesFlow: callStagesFlowReducer,
    windmillFlow: windmillFlowReducer,
    tools: toolsReducer,
    serverLogs: serverLogsReducer,
    callsPage: callsPageReducer,
    branding: brandingReducer,
    billing: billingReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'callStagesFlow/setNodes',
          'callStagesFlow/addNode',
          'callStagesFlow/updateNode',
        ],
        ignoredPaths: [
          'callStagesFlow.nodes',
          'callStagesFlow.edges',
          'callStagesFlow.selectedNode',
        ],
      },
    }),
});

// Export types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
